import RaioDeAtuacao from 'assets/images/banner_news_raio_de_atuacao.png';
import DrLicita from 'assets/images/banner_news_drlicita.png';
import NotificacoesWhatsapp from 'assets/images/banner_news_licitacoes_gerenciadas.png';
import BiddingViewed from 'assets/images/banner_news_marcar_como_lido.png';
import Robo from 'assets/images/banner-news-robo.png';
import BiddingSummary from 'assets/images/banner_news_informacoes_do_edital.png';
import AssistenteJuridico from 'assets/images/banner_news_assistente_juridico.png';
import AutenticarDocumentos from 'assets/images/banner_news_autenticar_documentos.png';
import ConlicitaSeg from 'assets/images/banner_news_conlicitaseg.png';

export const newsItems = [
  {
    modal: 'ConlicitaSeg',
    img: ConlicitaSeg,
    accessKey: [],
    new_badge: false,
  },
  {
    modal: 'BannerAuthenticateDocumentModal',
    img: AutenticarDocumentos,
    accessKey: [],
    new_badge: false,
  },
  {
    modal: 'BannerChatbotModal',
    img: AssistenteJuridico,
    accessKey: [],
    new_badge: false,
  },
  {
    modal: 'ModalRobo',
    img: Robo,
    accessKey: ['robo_access'],
    new_badge: false,
  },
  {
    modal: 'ModalDrlicita',
    img: DrLicita,
    accessKey: ['dr_licita_access'],
    new_badge: false,
  },
  {
    modal: 'BannerBiddingSummaryModal',
    img: BiddingSummary,
    accessKey: [],
    new_badge: false,
  },
  {
    modal: 'BannerRadarModal',
    img: RaioDeAtuacao,
    accessKey: [],
    new_badge: false,
  },
  {
    modal: 'BannerBondModal',
    img: NotificacoesWhatsapp,
    accessKey: [],
    new_badge: false,
  },
  {
    modal: 'ModalBiddingViewed',
    img: BiddingViewed,
    accessKey: [],
    new_badge: false,
  },
];
